export const INLINE_CODE_KEY = 'uui-richTextEditor-code';
export const INLINE_CODE_TYPE = 'uui-richTextEditor-code';
